export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      portfolio: "Portfolio",
      about: "About",
      consultations: "Consultations",
      gallery: "Gallery",
      contact: "Contact",
      bookNow: "Book a Consultation",
    },
    hero: {
      eyebrow: "Master Carpentry · London · Est. 25 Years",
      title: "Built by hand.\nFinished with intention.",
      subtitle:
        "Bespoke carpentry, private construction and 3D design consultations for clients who demand the work be done properly — the first time.",
      ctaPrimary: "Book a Consultation",
      ctaSecondary: "View Portfolio",
    },
    intro: {
      eyebrow: "The Studio",
      title: "Twenty-five years of quiet, careful work.",
      body:
        "From shop fittings on Marylebone High Street to listed cottages on the Surrey border, C-Carpenter has spent a quarter of a century building, restoring and remodelling some of London's most particular interiors. Three disciplines. One workshop. No shortcuts.",
    },
    services: {
      eyebrow: "Three Disciplines",
      title: "Where we work.",
      carpentry: {
        title: "Bespoke Carpentry",
        tag: "Joinery · Shop Fitting · Restoration",
        body:
          "Hand-built furniture, bookshelves, entertainment centres, walk-in wardrobes, shop fittings and full interior carpentry — restored and built to last generations.",
      },
      construction: {
        title: "Private Construction",
        tag: "Cottages · Granny Annexes · Full Remodels",
        body:
          "Whole-house remodels, cottage restorations, granny annexes and structural refits, managed end-to-end for private clients across Greater London.",
      },
      consult: {
        title: "Paid Consultations",
        tag: "Carpentry · Construction · 3D Design",
        body:
          "One-to-one expert sessions on bespoke joinery, build feasibility and 3D pre-visualization. Pay once, leave with answers.",
      },
      cta: "Learn more",
    },
    portfolio: {
      eyebrow: "Selected Work",
      title: "A quarter century, on record.",
      all: "All",
      carpentry: "Carpentry",
      construction: "Construction",
      consultation: "3D / Design",
      viewAll: "View all projects",
      empty: "No projects in this category yet.",
    },
    about: {
      eyebrow: "About",
      title: "A workshop, a code of practice, a long memory.",
      mission: {
        title: "Mission",
        body:
          "To build private interiors and structures that outlast the people who commissioned them — using traditional joinery, modern engineering and a refusal to cut corners.",
      },
      vision: {
        title: "Vision",
        body:
          "A London where good carpentry is the rule, not the exception. We work with a tight roster of clients each year, because the work asks for it.",
      },
      values: {
        title: "Values",
        items: [
          "Honesty in materials. Solid where solid is needed.",
          "Drawings before demolition. 3D before commitment.",
          "Site discipline. Quiet workshop, clean handover.",
          "One project at a time, properly finished.",
        ],
      },
    },
    consult: {
      eyebrow: "Paid Consultations",
      title: "Book a session.",
      subtitle:
        "Fixed price. Fixed length. Pay securely with Stripe. Use the form on the chosen service to send brief, dates and contact details.",
      duration: "Duration",
      price: "Price",
      book: "Book this consultation",
      formTitle: "Your details",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      date: "Preferred date (optional)",
      notes: "Brief / notes",
      payNow: "Pay & confirm",
      back: "← Back to services",
      canceled: "Payment cancelled. Your booking was not charged.",
    },
    bookingResult: {
      checking: "Confirming your payment…",
      success: "Payment confirmed.",
      successBody:
        "Thank you. Your consultation is booked. We'll be in touch within 24 hours to confirm a time.",
      pending: "Payment is being processed…",
      failed: "Payment was not completed.",
      backHome: "Back to home",
    },
    contact: {
      eyebrow: "Get in touch",
      title: "Tell us about the project.",
      subtitle:
        "Briefs, quote requests, restoration enquiries — we read every message. Replies within one working day.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sent: "Thank you — your message has been received.",
      error: "Something went wrong. Please try again.",
      address: "Workshop · London, United Kingdom",
      hours: "Mon – Fri · 08:00 – 18:00",
      phone: "Phone",
      whatsapp: "WhatsApp",
      followUs: "Follow the workshop",
    },
    gallery: {
      eyebrow: "Photo & Film",
      title: "From the workshop.",
      subtitle:
        "Photographs and short films of finished work. Albums by discipline. Subscribe to our YouTube channel for full project tours.",
      tabs: { photos: "Photographs", videos: "Films" },
      filters: { all: "All", carpentry: "Carpentry", construction: "Construction", consultation: "3D / Design" },
      empty: "No items yet in this album.",
      youtubeCta: "Watch on YouTube",
      instagramCta: "Follow on Instagram",
    },
    footer: {
      tagline: "Bespoke carpentry & private construction. London.",
      navigate: "Navigate",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
      rights: "All rights reserved.",
      admin: "Admin",
    },
    admin: {
      login: "Admin login",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      signOut: "Sign out",
      invalid: "Invalid credentials",
      dashboard: "Dashboard",
      projects: "Projects",
      bookings: "Bookings",
      messages: "Messages",
      transactions: "Transactions",
      media: "Gallery",
      settings: "Settings",
      addProject: "New project",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      confirmDelete: "Delete this project?",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      portfolio: "Portafolio",
      about: "Nosotros",
      consultations: "Consultorías",
      contact: "Contacto",
      bookNow: "Reservar Consultoría",
    },
    hero: {
      eyebrow: "Ebanistería de Maestros · Londres · 25 Años",
      title: "Hecho a mano.\nTerminado con intención.",
      subtitle:
        "Ebanistería a medida, construcción privada y consultorías de diseño 3D para clientes que exigen que el trabajo se haga bien — a la primera.",
      ctaPrimary: "Reservar Consultoría",
      ctaSecondary: "Ver Portafolio",
    },
    intro: {
      eyebrow: "El Taller",
      title: "Veinticinco años de trabajo, callado y cuidadoso.",
      body:
        "Desde shop fittings en Marylebone High Street hasta cottages protegidos en la frontera de Surrey, C-Carpenter ha pasado un cuarto de siglo construyendo, restaurando y remodelando algunos de los interiores más exigentes de Londres. Tres disciplinas. Un taller. Sin atajos.",
    },
    services: {
      eyebrow: "Tres Disciplinas",
      title: "Dónde trabajamos.",
      carpentry: {
        title: "Ebanistería a Medida",
        tag: "Carpintería · Shop Fitting · Restauración",
        body:
          "Muebles hechos a mano, bookshelves, centros de entretenimiento, walk-in closets, shop fittings y carpintería interior completa — restaurados y construidos para durar generaciones.",
      },
      construction: {
        title: "Construcción Privada",
        tag: "Cottages · Granny Annexes · Remodelaciones",
        body:
          "Remodelaciones de casa completa, restauración de cottages, granny annexes y refits estructurales, gestionados de principio a fin para clientes privados en Greater London.",
      },
      consult: {
        title: "Consultorías Pagadas",
        tag: "Ebanistería · Construcción · Diseño 3D",
        body:
          "Sesiones uno-a-uno con un experto sobre carpintería a medida, viabilidad de obra y pre-visualización 3D. Pagas una vez, sales con respuestas.",
      },
      cta: "Saber más",
    },
    portfolio: {
      eyebrow: "Obra Seleccionada",
      title: "Un cuarto de siglo, registrado.",
      all: "Todo",
      carpentry: "Ebanistería",
      construction: "Construcción",
      consultation: "3D / Diseño",
      viewAll: "Ver todos los proyectos",
      empty: "Aún no hay proyectos en esta categoría.",
    },
    about: {
      eyebrow: "Nosotros",
      title: "Un taller, un código de oficio, una memoria larga.",
      mission: {
        title: "Misión",
        body:
          "Construir interiores y estructuras privadas que sobrevivan a quienes los encargaron — usando ebanistería tradicional, ingeniería moderna y una negativa rotunda a tomar atajos.",
      },
      vision: {
        title: "Visión",
        body:
          "Un Londres donde la buena ebanistería sea la regla, no la excepción. Trabajamos con una lista corta de clientes cada año, porque el oficio lo exige.",
      },
      values: {
        title: "Valores",
        items: [
          "Honestidad en los materiales. Macizo donde tiene que ser macizo.",
          "Planos antes de la demolición. 3D antes del compromiso.",
          "Disciplina en obra. Taller silencioso, entrega limpia.",
          "Un proyecto a la vez, bien terminado.",
        ],
      },
    },
    consult: {
      eyebrow: "Consultorías Pagadas",
      title: "Reserva una sesión.",
      subtitle:
        "Precio fijo. Duración fija. Pago seguro con Stripe. Usa el formulario en el servicio elegido para enviar el brief, fechas y datos de contacto.",
      duration: "Duración",
      price: "Precio",
      book: "Reservar esta consultoría",
      formTitle: "Tus datos",
      name: "Nombre completo",
      email: "Email",
      phone: "Teléfono (opcional)",
      date: "Fecha preferida (opcional)",
      notes: "Brief / notas",
      payNow: "Pagar y confirmar",
      back: "← Volver a servicios",
      canceled: "Pago cancelado. No se ha cobrado tu reserva.",
    },
    bookingResult: {
      checking: "Confirmando tu pago…",
      success: "Pago confirmado.",
      successBody:
        "Gracias. Tu consultoría está reservada. Te contactamos en las próximas 24 horas para confirmar el horario.",
      pending: "El pago se está procesando…",
      failed: "El pago no se completó.",
      backHome: "Volver al inicio",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Cuéntanos sobre el proyecto.",
      subtitle:
        "Briefs, presupuestos, consultas de restauración — leemos cada mensaje. Respuesta en un día laboral.",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      subject: "Asunto",
      message: "Mensaje",
      send: "Enviar mensaje",
      sent: "Gracias — hemos recibido tu mensaje.",
      error: "Algo salió mal. Por favor intenta de nuevo.",
      address: "Taller · Londres, Reino Unido",
      hours: "Lun – Vie · 08:00 – 18:00",
      phone: "Teléfono",
      whatsapp: "WhatsApp",
      followUs: "Sigue el taller",
    },
    gallery: {
      eyebrow: "Foto y Video",
      title: "Desde el taller.",
      subtitle:
        "Fotografías y cortos del trabajo terminado. Álbumes por disciplina. Suscríbete a nuestro canal de YouTube para ver recorridos completos de proyecto.",
      tabs: { photos: "Fotografías", videos: "Videos" },
      filters: { all: "Todo", carpentry: "Ebanistería", construction: "Construcción", consultation: "3D / Diseño" },
      empty: "Aún no hay elementos en este álbum.",
      youtubeCta: "Ver en YouTube",
      instagramCta: "Seguir en Instagram",
    },
    footer: {
      tagline: "Ebanistería a medida y construcción privada. Londres.",
      navigate: "Navegar",
      legal: "Legal",
      privacy: "Privacidad",
      terms: "Términos",
      rights: "Todos los derechos reservados.",
      admin: "Admin",
    },
    admin: {
      login: "Acceso admin",
      email: "Email",
      password: "Contraseña",
      signIn: "Entrar",
      signOut: "Salir",
      invalid: "Credenciales inválidas",
      dashboard: "Panel",
      projects: "Proyectos",
      bookings: "Reservas",
      messages: "Mensajes",
      transactions: "Transacciones",
      media: "Galería",
      settings: "Configuración",
      addProject: "Nuevo proyecto",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      confirmDelete: "¿Eliminar este proyecto?",
    },
  },
};
